<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header>
        Visitors
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <gg-select
              v-model="selectedDomain"
              label="Select a Domain"
              item-text="txt"
              return-object
              :loading="loadingDomains"
              :items="domains"
            />
          </v-col>
          <v-col cols="12" md="6">
            <gg-text-field
              v-model="table.search"
              hide-details
              label="Search"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :loading="loadingVisitors"
              :headers="table.headers"
              :items="visitors"
              :search="table.search"
              :footer-props="{ itemsPerPageOptions: pagination }"
              sort-by="timestamp">
<!--              <template #item.path="{ item }">-->
<!--                <a :href="`http${selectedDomain.ssl ? 's' : ''}://${selectedDomain.domain}${item.path}`"-->
<!--                   target="_blank">-->
<!--                  {{ item.path }}-->
<!--                </a>-->
<!--              </template>-->
<!--              <template #item.timestamp="{ item }">-->
<!--                {{ formattedDate(item.timestamp) }}-->
<!--              </template>-->
              <template #item.date="{ item }">
                {{ formattedDate(item.date) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { format, parse } from 'date-fns'

export default {
  name: 'VisitorsList',
  data () {
    return {
      loadingDomains: false,
      loadingVisitors: false,
      selectedDomain: null,
      table: {
        headers: [
          // { text: 'IP', value: 'ip' },
          // { text: 'URL', value: 'path' },
          // { text: 'Time', value: 'timestamp' },
          // { text: 'Size (bytes)', value: 'size' },
          // { text: 'Referring URL', value: 'referrer' },
          // { text: 'User Agent', value: 'agent' },
          { text: 'URL', value: 'url' },
          { text: 'Time', value: 'date' },
        ],
        search: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      hosting: 'hosting',
      visitorsDomains: 'hosting_stats/hostingVisitorsDomains',
      visitors: 'hosting_stats/hostingVisitors',
      pagination: 'pagination'
    }),
    items () {
      return this.visitors.filter(v => v.timestamp > 0)
    },
    domains () {
      return this.visitorsDomains // .filter(domain => !domain.ssl)
    },
  },
  methods: {
    ...mapActions({
      loadVisitorsDomains: 'hosting_stats/loadVisitorsDomains',
      loadVisitors: 'hosting_stats/loadVisitors',
      reportError: 'reportError',
    }),
    async getDomains () {
      this.loadingDomains = true
      try {
        await this.loadVisitorsDomains()
        if (this.visitorsDomains.length) {
          this.selectedDomain = this.visitorsDomains[0]
        }
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingDomains = false
      }
    },
    async getVisitors () {
      this.loadingVisitors = true
      try {
        await this.loadVisitors(this.selectedDomain)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loadingVisitors = false
      }
    },
    formattedDate (timestamp) {
      if (timestamp < 1) return ''
      return format(parse(timestamp, 't', new Date()), 'dd/MM/yy h:mm a')
    }
  },
  mounted () {
    this.getDomains()
  },
  watch: {
    selectedDomain (val) {
      this.getVisitors()
    }
  }
}
</script>
